import { render } from "./EmployeeList.vue?vue&type=template&id=61017bd2&ts=true"
import script from "./EmployeeList.ts?vue&type=script&lang=ts&external"
export * from "./EmployeeList.ts?vue&type=script&lang=ts&external"

import "../PatientList/PatientList.scss?vue&type=style&index=0&lang=scss&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__